/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  RESET_TRAVEL_DELAY_STATE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormTravelInterruption() {
  return {
    type: RESET_TRAVEL_INTERRUPTION_STATE,
  };
}
export function resetFormTravelDelay() {
  return {
    type: RESET_TRAVEL_DELAY_STATE,
  };
}

export function handleFormDataEnableTime(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripCancellationStep/actions.js